'use client';

import { FC } from 'react';
import { SampleSelectionDialog } from './SampleSelectionDialog';
import { useDialogStore } from '@/stores/dialogStore';
import { SampleRowType } from '@/components/tables/SampleGridCore';
import { SampleDto } from '@/api/ApiClient';

/**
 * Wrapper component that connects SampleSelectionDialog to the dialog store.
 * This is the global instance that should be rendered once in the app.
 */
export const SampleSelectionDialogWrapper: FC = () => {
  const { sampleSelectionDialog, closeSampleSelectionDialog } = useDialogStore();

  // Set by showSampleSelectionDialog(..., { allowMultiple: false }) for one-at-a-time pickers
  // (e.g. Multi-Sample Growth "Pick sample"). Omitted or true = checkboxes + "Use Selection".
  const allowMultiple = sampleSelectionDialog.allowMultiple !== false;

  /** Multi-select path: user checked rows and clicked "Use Selection". */
  const handleSamplesSelect = (samples: SampleRowType[]) => {
    const sampleDtos: SampleDto[] = samples.map((sample) => ({
      id: sample.id,
      sampleLabel: sample.sampleLabel,
    }));

    closeSampleSelectionDialog(sampleDtos);
  };

  const handleClose = () => {
    closeSampleSelectionDialog();
  };

  return (
    <SampleSelectionDialog
      open={sampleSelectionDialog.isOpen}
      title={sampleSelectionDialog.title || 'Select Samples'}
      allowMultiple={allowMultiple}
      disabledSampleIds={sampleSelectionDialog.disabledSampleIds}
      initialFilters={sampleSelectionDialog.initialFilters}
      onSamplesSelect={handleSamplesSelect}
      onSampleSelect={(sample) => {
        // Single-select: one row click resolves the promise with one sample.
        handleSamplesSelect([sample]);
      }}
      onClose={handleClose}
    />
  );
};
